import {  useEffect, useState, FunctionComponent, useContext, ChangeEvent } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import {
  FormControl,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import styles from "./AppTable.module.css";
import {
  EnhancedTableHead, listTicketsRowType, manageticketsrowType, eventsRowType,
  roles,
  VenuesRowType
} from "../../../helper";
import { AddTicketsErrorTableBody, AffiliatePopupUsersTableBody, AffiliateTransactionsUsersTableBody, AffiliateUsersTableBody, DelistAndReturnTicketTableBody, DelistAndUnsoldTicketTableBody, EventsTableBody, ListTicketTableBody, ManageTicketTableBody, PublishTicketsErrorTableBody, ScrapeEventErrorTableBody, SoldTicketTableBody, SoldTicketsErrorTableBody, StripePaymentsErrorTableBody, StripePayoutErrorTableBody, UsersTableBody, AddTicketsManuallyErrorTableBody, VenuesTableBody, SuperUsersTableBody, AuditLogitixLogsTableBody } from "./TableHelper";
import { useMutation } from "@apollo/client";
import { PUBLISH_TICKETS } from "../../../features/Tickets/api/TicketsQuery";
import ToasterWithMessage from "../toaster";
import { globalContext } from "../../../Provider/AppProvider";
import { affiliateUsersListType } from "../../../features/Affiliate/Affiliate";
import { table } from "console";
import AuditLogitixLogs from "../auditLogs/AuditLogitixLogs";


export interface User {
  u_id: string;
  u_active_tickets: number;
  u_country_code: string;
  u_created_at: string;
  u_email_id: string;
  u_first_name: string;
  u_is_active: boolean;
  u_last_name: string;
  u_last_online: string | null;
  u_phone_number: string;
  u_full_name: string;
  u_total_earnings: number;
}

interface UserAggregateFields {
  count: number;
}

interface UserAggregate {
  aggregate: UserAggregateFields;
}

interface UserData {
    user: User[];
    user_referred_by_aggregate: {
      aggregate: {
        count: number
      }
    },
    user_aggregate: UserAggregate;
}

interface ListData {
  filterlisttickets: listTicketsRowType;
  filterlisttickets_aggregate: {
    aggregate: {
      count: number
    }
  }
}


interface AppTableprops {
  handleChangeRowsPerPage : (e:any) => void;
  handlePageChange : (e : ChangeEvent<unknown>, newPage : number) => void
  setColumnTypes : (property : string) => void
  sortType : string
  setSortType : (value : string) => void
  /** When set, sort direction toggles only if the user clicks the same column; switching columns uses sensible defaults (e.g. e_date → desc). */
  sortColumn?: string
  setSelected : (value : number[]) => void
  setChecking : (value : boolean) => void
  checking : boolean
  selected : number[]
  rowsPerPage: number
  setCurrentPage : (value : number) => void
  currentPage : number
  list : UserData | ListData | affiliateUsersListType | any
  tableTitle: string
  generateHeadCells: () => {}[]
  setSelectedUsers?: (users: string[]) => void;
  selectedUsers?: string[] | []
  selectedTickets ? : string[] | []
  setSelectedTickets ? : (tickets: string[]) => void 
  setSelectedEvents?: (events: string[]) => void;
  selectedEvents?: string[] | []
  setSelectedVenues?: (events: string[]) => void;
  selectedVenues?: string[] | []
  handleDropdownChange ? : (e : SelectChangeEvent<unknown> , index : number ,rowid :string ) => void
  selectedValues ?: string[]
  setSelectedValues ?: (values : string[] ) => void
  setSelectedUsersToVerify ?: any,
  affiliateDetailsView?: any,
  setAffiliateDetailsView?: any
  setUsersList?: (list: any) => void,
  tablePurpose?: string,
  isSportsLeagueTable?: boolean
  refetchSuperUsersData?:() => Promise<any>
  setSuperUsersList?: (superUsersList: any) => void;
} 


const AppTable: FunctionComponent<AppTableprops> = ({
  handleChangeRowsPerPage,
  handlePageChange,
  setColumnTypes,
  sortType,
  setSortType,
  sortColumn,
  setSelected,
  setChecking,
  checking,
  selected,
  rowsPerPage,
  setCurrentPage,
  currentPage,
  list,
  tableTitle,
  generateHeadCells,
  setSelectedUsers,
  selectedUsers,
  setSelectedEvents,
  selectedEvents,
  setSelectedTickets,
  handleDropdownChange,
  selectedTickets,
  selectedValues,
  setSelectedValues,
  setSelectedUsersToVerify,
  affiliateDetailsView,
  setAffiliateDetailsView,
  setUsersList,
  tablePurpose,
  setSelectedVenues,
  selectedVenues,
  isSportsLeagueTable,
  refetchSuperUsersData,
  setSuperUsersList
}) => {
  const [anchorEl, setAnchorEl] = useState<EventTarget | null>(null);
  const open = Boolean(anchorEl);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {error,success} = ToasterWithMessage();
  const {globalState,handleGlobalState} = useContext<any>(globalContext)


  const handleIconClick = () => {
    setIsDropdownOpen(!isDropdownOpen); // Toggles the dropdown state
  };

 
  const [publishTicket] = useMutation(PUBLISH_TICKETS,{
    fetchPolicy:'network-only',
    onCompleted : (data) =>{
      if (data) {
        success("Published successfully");
        const tempState = {...globalState}
        globalState.publishticket.publish = true
        handleGlobalState(tempState)
       }
       setSelected([])
       if(setSelectedTickets)
       setSelectedTickets([])
    },
    onError: () =>{
      setSelected([])
      if(setSelectedTickets)
      setSelectedTickets([])
      error("Something went wrong!")
    }
  })
  const publishATicket = (value:boolean, rowId : string, listPrice: number) =>{
    publishTicket({
      variables:{
        publishTicketsInput:{
          ticketPlacementIds:[rowId],
          listPrice:listPrice
          }
      }
    })
 }

  const handleClickOpenmenu = (event: React.MouseEvent<HTMLInputElement>) => {
    setChecking(false);
    setSelected([]);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleRequestSort = (_event: React.MouseEvent, property: string) => {
    const effectiveColumn = property === "periodleft" ? "e_date" : property;
    if (property === "periodleft") {
      setColumnTypes("e_date");
    } else {
      setColumnTypes(property);
    }
    if (sortColumn !== undefined) {
      if (effectiveColumn === sortColumn) {
        setSortType(sortType === "asc" ? "desc" : "asc");
      } else {
        setSortType(effectiveColumn === "e_date" ? "desc" : "asc");
      }
    } else if (sortType === "asc") {
      setSortType("desc");
    } else {
      setSortType("asc");
    }
    setSelected([]);
    if(setSelectedUsers){
      setSelectedUsers([]);
    }
    if(setSelectedUsersToVerify)
    setSelectedUsersToVerify([]);
    setChecking(false);
  };

  /* For select the all users using global checkbox */
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      if(tableTitle === 'users'){
        const newSelected : number[]= list?.user?.map(
          (_n: User, index: number) => index
        );
        const newSelectedUsers : string[] = list?.user?.map(
          (user: User) => user?.u_id 
        );
        const selectedUserToVerify: any = list?.user?.map(
          (user: User) => user
        );
        if(setSelectedUsersToVerify)
        setSelectedUsersToVerify(selectedUserToVerify);
        setSelected(newSelected);
        if(setSelectedUsers){
        setSelectedUsers(newSelectedUsers);
        }
        setChecking(!checking);
        return;
      }else if(tableTitle === 'managetickets'){
        const newSelected : number[]= list?.filtermanagetickets?.map(
          (_n: manageticketsrowType, index: number) => index
        );
        const newSelectedTickets : string[] = list?.filtermanagetickets?.map(
          (tickets: manageticketsrowType) => tickets?.tp_id
        );

        if(setSelectedTickets){
          setSelectedTickets(newSelectedTickets)
        }
        setSelected(newSelected);
        setChecking(!checking);
        return;
      }else if(tableTitle === 'listtickets'){
        const newSelected : number[]= list?.filterlisttickets?.map(
          (_n: listTicketsRowType, index: number) => index
        );
        const newSelectedTickets : string[] = list?.filterlisttickets?.map(
          (tickets: listTicketsRowType) => tickets?.tp_id
        );

        if(setSelectedTickets){
          setSelectedTickets(newSelectedTickets)
        }   
        setSelected(newSelected);
        setChecking(!checking);
        return;
      }else if(tableTitle === 'pickEvents' || tableTitle === 'pickEventsBulkList'){
        const newSelected : number[]= list?.events?.map(
          (_n: eventsRowType, index: number) => index
        );
        const newSelectedEvents : string[] = list?.events?.map(
          (events: eventsRowType) => events?.e_id
        );

        if(setSelectedEvents){
          setSelectedEvents(newSelectedEvents)
        }
        setSelected(newSelected);
        setChecking(!checking);
        return;
      }else if(tableTitle === 'pickVenues'){
        const newSelected : number[]= list?.venues?.map(
          (_n: VenuesRowType, index: number) => index
        );
        const newSelectedEvents : string[] = list?.venues?.map(
          (venue: VenuesRowType) => venue.ltv_id
        );

        if(setSelectedVenues){
          setSelectedVenues(newSelectedEvents)
        }
        setSelected(newSelected);
        setChecking(!checking);
        return;
      }
    }
    setSelected([]);
    if(setSelectedUsers){
    setSelectedUsers([]);
    }
    if(setSelectedUsersToVerify)
      setSelectedUsersToVerify([]);
    if(setSelectedTickets){
      setSelectedTickets([])
    }
    if(setSelectedEvents){
      setSelectedEvents([])
    }
    if(setSelectedVenues){
      setSelectedVenues([])
    }
   
  };

  /* For selecting the users by click the checkbox */
  const handleClick = (_event: React.ChangeEvent<HTMLInputElement>, id: number,rowId: string) => {
    const selectedIndex = selected?.indexOf(id);
    let newSelected:any = [];
    let selectedRows: any = [];
    let selectedbox:any = []
    if(tableTitle === 'users'){
      selectedbox = selectedUsers
    }else if(tableTitle === 'managetickets' || tableTitle === 'listtickets'){
      selectedbox = selectedTickets
    } else if(tableTitle === 'pickEvents' || tableTitle === 'pickEventsBulkList') {
      selectedbox = selectedEvents
    }else if(tableTitle === 'pickVenues') {
      selectedbox = selectedVenues
    }
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
      selectedRows = selectedRows.concat(selectedbox,rowId) 
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected?.slice(1));
      selectedRows = selectedRows.concat(selectedbox?.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected?.slice(0, -1));
      selectedRows = selectedRows.concat(selectedbox?.slice(0,-1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected?.slice(0, selectedIndex),
        selected?.slice(selectedIndex + 1)
      );
      selectedRows = selectedRows.concat(
        selectedbox?.slice(0,selectedIndex),
        selectedbox?.slice(selectedIndex+1)
      )
    }
    const filterUsers = list?.user?.filter((data: User) => selectedRows.includes(data?.u_id))
                                   .map((value: User) => value);
    if(setSelectedUsersToVerify)
    setSelectedUsersToVerify(filterUsers);
    if(setSelectedUsers){
    setSelectedUsers(selectedRows);
    } 
    if(setSelectedTickets){
      setSelectedTickets(selectedRows)
    }
    if(setSelectedEvents){
      const selectedRow = tableTitle === 'pickEventsBulkList' ? selectedRows : [rowId]
      setSelectedEvents(selectedRow)
    }
    if(setSelectedVenues){
      const selectedRow = [rowId]
      setSelectedVenues(selectedRow)
    }
    
    setSelected(newSelected);
  };

  
  const [paginationBoxCount, setPaginationBoxCount] = useState(
    tableTitle === 'users'
   ? Math.ceil(list?.user_aggregate?.aggregate?.count / rowsPerPage)
   : (tableTitle === 'listtickets')
      ? Math.ceil(list?.filterlisttickets_aggregate?.aggregate?.count / rowsPerPage)
      : (tableTitle === 'soldTickets')
         ? Math.ceil(list?.FilterSoldTickets_aggregate?.aggregate?.count / rowsPerPage)
         : (tableTitle === 'delistAndReturnTickets')
           ? Math.ceil(list?.filterreturntickets_aggregate?.aggregate?.count / rowsPerPage)
           : (tableTitle === 'delistAndUnsoldTickets')
              ? Math.ceil(list?.filterUnsoldTickets_aggreagate?.aggregate?.count / rowsPerPage)
              : (tableTitle === 'affiliate' || tableTitle === 'affiliatePopup') 
                 ? Math.ceil(list?.getAffiliatesCount/rowsPerPage)
                 : (tableTitle === 'affiliateTransactions') 
                 ? Math.ceil(list?.affiliateTransactionsCount/rowsPerPage)
                 : (tableTitle === 'managetickets')
                    ? Math.ceil(list?.filtermanagetickets_aggregate?.aggregate?.count/ rowsPerPage)
                    : (tableTitle === 'stripePaymentsError')
                      ?Math.ceil(list?.stripe_errors_aggregate?.aggregate?.count/ rowsPerPage)
                      :(tableTitle === 'scrapEventError')
                        ?Math.ceil(list?.event_errors_aggregate?.aggregate?.count/ rowsPerPage)
                        :(tableTitle === 'addTicketsError'||tableTitle === 'soldTicketsError'||tableTitle === 'publishTicketsError')
                          ?Math.ceil(list?.getTicketsMail?.ticketsLength/ rowsPerPage)
                          : (tableTitle === 'stripePayoutError')
                            ?Math.ceil(list?.payout_errors_aggregate?.aggregate?.count/ rowsPerPage)
                            :(tableTitle === 'stripePayoutSuccess')
                              ?Math.ceil(list?.payouts_succeed_aggregate?.aggregate?.count/ rowsPerPage)
                                :(tableTitle === 'pickEvents' || tableTitle === 'pickEventsBulkList')
                                ?Math.ceil(list?.events_aggregate?.aggregate?.count/ rowsPerPage)
                                : tableTitle === 'pickVenues'
                                  ? Math.ceil(list?.venues_aggregate?.aggregate?.count / rowsPerPage)
                                    :(tableTitle === 'manualTicketsError')
                                      ? Math.ceil(list?.AddTicketByAdminLogsCount?.[0]?.totalCount/ rowsPerPage) 
                                        :(tableTitle === 'auditLogitixLogs') ?
                                          Math.ceil(list?.logitix_audit_logs?.length/ rowsPerPage)
                                            :(tableTitle === 'superUsersTable') ?
                                              Math.ceil(list?.super_users?.length/ rowsPerPage)
                                                :Math.ceil(10 / rowsPerPage)
      );
  
  const isSelected = (id: number) => {
    return selected?.indexOf(id) !== -1;
  };

  useEffect(() => {
    if(tableTitle === 'users'){
      setPaginationBoxCount(Math.ceil(list?.user_aggregate?.aggregate?.count / rowsPerPage))
    }else if (tableTitle === 'managetickets'){
      setPaginationBoxCount(Math.ceil(list?.filtermanagetickets_aggregate?.aggregate?.count / rowsPerPage))
    }else if(tableTitle === 'listtickets'){
      setPaginationBoxCount(Math.ceil(list?.filterlisttickets_aggregate?.aggregate?.count / rowsPerPage))
    }else if(tableTitle === "soldTickets"){
      setPaginationBoxCount(Math.ceil( list?.FilterSoldTickets_aggregate?.aggregate?.count / rowsPerPage))
    }else if(tableTitle === 'delistAndReturnTickets'){
      setPaginationBoxCount(Math.ceil(list?.filterreturntickets_aggregate?.aggregate?.count / rowsPerPage))
    }else if(tableTitle === 'delistAndUnsoldTickets'){
      setPaginationBoxCount(Math.ceil(list?.filterUnsoldTickets_aggreagate?.aggregate?.count / rowsPerPage))
    }else if(tableTitle === 'affiliate' || tableTitle === 'affiliatePopup'){
      setPaginationBoxCount(Math.ceil(list?.getAffiliatesCount/rowsPerPage))
    }else if(tableTitle === 'affiliateTransactions') {
      setPaginationBoxCount(Math.ceil(list?.affiliateTransactionsCount/rowsPerPage))
    }else if(tableTitle === 'stripePaymentsError'){
      setPaginationBoxCount(Math.ceil(list?.stripe_errors_aggregate?.aggregate?.count/ rowsPerPage))
    }else if(tableTitle === 'stripePayoutError'){
      setPaginationBoxCount(Math.ceil(list?.payout_errors_aggregate?.aggregate?.count/ rowsPerPage))
    }else if(tableTitle === 'stripePayoutSuccess'){
      setPaginationBoxCount(Math.ceil(list?.payouts_succeed_aggregate?.aggregate?.count/ rowsPerPage))
    }else if(tableTitle === 'scrapEventError'){
      setPaginationBoxCount(Math.ceil(list?.event_errors_aggregate?.aggregate?.count/ rowsPerPage))
    }else if(tableTitle === 'addTicketsError'){
      setPaginationBoxCount(Math.ceil(list?.getTicketsMail?.ticketsLength/ rowsPerPage))
    }else if(tableTitle === 'publishTicketsError'){
      setPaginationBoxCount(Math.ceil(list?.getTicketsMail?.ticketsLength/ rowsPerPage))
    }else if(tableTitle === 'soldTicketsError'){
      setPaginationBoxCount(Math.ceil(list?.getTicketsMail?.ticketsLength/ rowsPerPage))
    } else if(tableTitle === 'pickEvents' || tableTitle === 'pickEventsBulkList') {
      setPaginationBoxCount(Math.ceil(list?.events_aggregate?.aggregate?.count/ rowsPerPage))
    }else if (tableTitle === 'pickVenues') {
      setPaginationBoxCount(Math.ceil(list?.venues_aggregate?.aggregate?.count / rowsPerPage))
    }else if(tableTitle === 'manualTicketsError'){
      setPaginationBoxCount(Math.ceil(list?.AddTicketByAdminLogsCount?.[0]?.totalCount/ rowsPerPage))
    }else if(tableTitle === 'superUsersTable'){
      setPaginationBoxCount(Math.ceil(list?.super_users?.length/ rowsPerPage))
    }else if(tableTitle === 'auditLogitixLogs'){
      setPaginationBoxCount(Math.ceil(list?.logitix_audit_logs?.length/ rowsPerPage))
    }
    else{
      setPaginationBoxCount(Math.ceil(10 / rowsPerPage))
    }
    setSelected([]);
    if(setSelectedUsers){
    setSelectedUsers([]);
    }
    if(setSelectedUsersToVerify)
    setSelectedUsersToVerify([]);
    setChecking(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, list]);

  useEffect(() => {
    if (currentPage > paginationBoxCount) {
      setCurrentPage(1);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, paginationBoxCount]);

  let result: number;

    if (tableTitle === "users") {
      if (list?.user?.length) {
        result = list?.user?.length;
      } else {
        result = 10;
      }
    } else if (tableTitle === "managetickets") {
      if (list?.filtermanagetickets?.length) {
        result = list?.filtermanagetickets?.length;
      } else {
        result = 10;
      }
    }else if (tableTitle === "listtickets") {
      if (list?.filterlisttickets?.length) {
        result = list?.filterlisttickets?.length;
      } else {
        result = 10;
      }
    } else if(tableTitle === "soldTickets") {
      if(list?.FilterSoldTickets?.length){
        result =list?.FilterSoldTickets?.length
      }else{
        result = 10
      }
    }else if (tableTitle === "delistAndReturnTickets") {
      if (list?.filterreturntickets?.length) {
        result = list?.filterreturntickets?.length;
      } else {
        result = 10;
      }
    }else if (tableTitle === "delistAndUnsoldTickets") {
      if (list?.filterUnsoldTickets?.length) {
        result = list?.filterUnsoldTickets?.length;
      } else {
        result = 10;
      }
    }else if(tableTitle === "stripePaymentsError") {
      if(list?.stripe_errors?.length){
        result =list?.stripe_errors?.length
      }else{
        result = 10
      }
    }else if(tableTitle === "stripePayoutError") {
      if(list?.payout_errors?.length){
        result =list?.payout_errors?.length
      }else{
        result = 10
      }
    }else if(tableTitle === "stripePayoutSuccess") {
      if(list?.payouts_succeed?.length){
        result =list?.payouts_succeed?.length
      }else{
        result = 10
      }
    }else if(tableTitle === "scrapEventError") {
      if(list?.event_errors?.length){
        result =list?.event_errors?.length
      }else{
        result = 10
      }
    }else if (tableTitle === "pickEvents" || tableTitle === 'pickEventsBulkList') {
      if (list?.events?.length) {
        result = list?.events?.length;
      } else {
        result = 10;
      }
    }else if (tableTitle === "pickVenues") {
      if (list?.venues?.length) {
        result = list?.venues?.length;
      } else {
        result = 10;
      }
    }
    else if (tableTitle === "manualTicketsError") {
      if (list?.AddTicketByAdminLogs?.length) {
        result = list?.AddTicketByAdminLogs?.length;
      } else {
        result = 10;
      }
    } else if ( tableTitle === "superUsersTable"){
      if (list?.super_users?.length) {
        result = list?.super_users?.length;
      } else {
        result = 10;
      }
    }else if ( tableTitle === "auditLogitixLogs"){
      if (list?.logitix_audit_logs?.length) {
        result = list?.logitix_audit_logs?.length; 
      } else {
        result = 10;
      }
    }
    else{
      result = 10
    }
  const showTable = ((list && list?.filtermanagetickets && list?.filtermanagetickets.length > 0) || 
                    (list && list?.filterlisttickets && list?.filterlisttickets.length > 0) || 
                    (list && list?.FilterSoldTickets && list?.FilterSoldTickets.length > 0) ||
                    (list && list?.filterreturntickets && list?.filterreturntickets.length > 0) || 
                    (list && list?.filterUnsoldTickets && list?.filterUnsoldTickets.length > 0) || 
                    (list && list?.getAffiliates && list?.getAffiliates?.length > 0) ||
                    (list && list?.affiliateTransactions && list?.affiliateTransactions?.length > 0) ||
                    (list && list?.user && list.user.length > 0) ||
                    (list && list?.getTicketsMail?.ticketsData && list?.getTicketsMail?.ticketsData.length > 0) ||
                    (list && list?.stripe_errors && list?.stripe_errors.length > 0) ||
                    (list && list?.event_errors && list?.event_errors.length > 0) ||
                    (list && list?.payout_errors && list?.payout_errors.length > 0)||
                    (list && list?.payouts_succeed && list?.payouts_succeed.length > 0) ||
                    (list && list?.events && list?.events?.length > 0) ||
                    (list && list?.venues && list?.venues?.length > 0) ||
                    (list && list?.AddTicketByAdminLogs && list?.AddTicketByAdminLogs?.length > 0) || 
                    (list && list?.super_user && list?.super_user.length > 0) || 
                    (list && list?.logitix_audit_logs && list?.logitix_audit_logs.length > 0)
                    //(tableTitle === 'superUsersTable')
                  );

  /** Super user, listed tickets: show header, empty row, and pagination when the query returns zero rows. */
  const listTicketsAggCount =
    tableTitle === "listtickets"
      ? list?.filterlisttickets_aggregate?.aggregate?.count
      : undefined;
  const isSuperUserListTicketsEmpty =
    tableTitle === "listtickets" &&
    globalState.profile.userRole === roles.SUPER_USER &&
    Number(listTicketsAggCount) === 0 &&
    (!list?.filterlisttickets ||
      (Array.isArray(list.filterlisttickets) && list.filterlisttickets.length === 0));

  const showTableBody = showTable || isSuperUserListTicketsEmpty;
  const showPaginationFooter = showTable || isSuperUserListTicketsEmpty;

  return (
    <>
      <div className={styles.overallcontainer}>
        <div className={styles.tablecontainer}>
          <TableContainer className={styles.muitablecontainer}>
            <Table stickyHeader aria-labelledby="tableTitle">
              <EnhancedTableHead
                generateHeadCells = {generateHeadCells}
                numSelected={selected?.length}
                onSelectAllClick={(e:any)=>handleSelectAllClick(e)}
                onRequestSort={handleRequestSort}
                rowCount={result}
                className={styles.tableheader}
                checking={checking}
                setChecking={setChecking}
                tableTitle = {tableTitle}
                purpose = {tablePurpose}
              />
              {
                 showTableBody
              &&
              (
                isSuperUserListTicketsEmpty ? (
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={
                          1 + (generateHeadCells() as { id: string }[]).length
                        }
                        align="center"
                        className={styles.noDataMessageInTable}
                      >
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) :
                (tableTitle === 'users')
              ?  
                    <UsersTableBody 
                      list = {list}
                      isSelected = {isSelected}
                      handleClick = {handleClick}
                      hanleclickopenmenu = {handleClickOpenmenu}
                      anchorEl = {anchorEl}
                      open={open}
                      setCurrentPage= {setCurrentPage}
                      handleClose = {handleClose}
                      setColumnTypes= {setColumnTypes}
                      setSortType = {setSortType}
                      setChecking = {setChecking}
                      setSelected = {setSelected}
                      setUsersList = {setUsersList}
                    />
              : (tableTitle === 'managetickets') 
                  ?
                        <ManageTicketTableBody
                        list={list}
                        isSelected={isSelected}
                        setCurrentPage = {setCurrentPage}
                        handleClick={handleClick}
                        handleIconClick={handleIconClick}
                        handleDropdownChange={handleDropdownChange}
                        selectedValues={selectedValues}
                        setSelectedValues={setSelectedValues}
                        publishATicket={publishATicket}
                        setColumnTypes = {setColumnTypes}
                        setSortType = {setSortType}
                      />  
                  : (tableTitle === 'listtickets')
                      ?   <ListTicketTableBody
                          list={list}
                          handleClick={handleClick}
                          isSelected={isSelected}
                          setCurrentPage = {setCurrentPage}
                          setColumnTypes = {setColumnTypes}
                          setSortType = {setSortType}
                          /> 
                      : (tableTitle === 'soldTickets')
                          ?    <SoldTicketTableBody
                                  list={list}
                                  isSelected={isSelected}
                                  setCurrentPage = {setCurrentPage}
                                  setColumnTypes = {setColumnTypes}
                                  setSortType = {setSortType}
                                />
                         : (tableTitle === 'delistAndReturnTickets')
                           ?   <DelistAndReturnTicketTableBody
                                list={list}
                                isSelected={isSelected}
                                setColumnTypes = {setColumnTypes}
                                setSortType = {setSortType}
                              />       
                            : (tableTitle === 'delistAndUnsoldTickets')
                              ?   <DelistAndUnsoldTicketTableBody
                                   list={list}
                                   isSelected={isSelected}
                                   setColumnTypes = {setColumnTypes}
                                   setSortType = {setSortType}
                                  />       
                              :  (tableTitle === 'addTicketsError')
                                  ? <AddTicketsErrorTableBody
                                      list = {list}
                                      isSelected = {isSelected}
                                      setCurrentPage = {setCurrentPage}
                                      setColumnTypes = {setColumnTypes}
                                      setSortType = {setSortType}
                                    />
                                  : (tableTitle === 'publishTicketsError')
                                    ? <PublishTicketsErrorTableBody
                                        list = {list}
                                        isSelected = {isSelected}
                                        setCurrentPage = {setCurrentPage}
                                        setColumnTypes = {setColumnTypes}
                                        setSortType = {setSortType}
                                        />
                                    : (tableTitle === 'soldTicketsError')
                                       ? <SoldTicketsErrorTableBody
                                            list = {list}
                                            isSelected = {isSelected}
                                            setCurrentPage = {setCurrentPage}
                                            setColumnTypes = {setColumnTypes}
                                            setSortType = {setSortType}
                                          />
                                       : (tableTitle === 'stripePaymentsError')
                                          ? <StripePaymentsErrorTableBody
                                                list = {list}
                                                isSelected = {isSelected}
                                                setCurrentPage = {setCurrentPage}
                                                setColumnTypes = {setColumnTypes}
                                                setSortType = {setSortType}
                                              />
                                          : (tableTitle === 'stripePayoutError'||tableTitle === 'stripePayoutSuccess')
                                             ? <StripePayoutErrorTableBody
                                                     list = {list}
                                                     isSelected = {isSelected}
                                                     setCurrentPage = {setCurrentPage}
                                                     setColumnTypes = {setColumnTypes}
                                                     setSortType = {setSortType}
                                                />
                                            : (tableTitle === 'scrapEventError')
                                              ? <ScrapeEventErrorTableBody
                                                     list = {list}
                                                     isSelected = {isSelected}
                                                     setCurrentPage = {setCurrentPage}
                                                     setColumnTypes = {setColumnTypes}
                                                     setSortType = {setSortType}
                                                 />
                                               : (tableTitle === 'affiliate')
                                                  ? <AffiliateUsersTableBody
                                                      list={list}
                                                      isSelected={isSelected}
                                                      setCurrentPage= {setCurrentPage}
                                                      setColumnTypes={setColumnTypes}
                                                      setSortType = {setSortType}
                                                      affiliateDetailsView = {affiliateDetailsView}
                                                      setAffiliateDetailsView = {setAffiliateDetailsView}
                                                  /> 
                                               : (tableTitle === "affiliateTransactions") ?
                                                  <AffiliateTransactionsUsersTableBody
                                                    list={list}
                                                    isSelected={isSelected}
                                                    setCurrentPage= {setCurrentPage}
                                                    setColumnTypes={setColumnTypes}
                                                    setSortType = {setSortType}
                                                    affiliateDetailsView = {affiliateDetailsView}
                                                    setAffiliateDetailsView = {setAffiliateDetailsView}
                                                  /> :
                                                  (tableTitle === 'pickEvents' || tableTitle === 'pickEventsBulkList') 
                                                  ?
                                                 <EventsTableBody
                                                     tableTitle = {tableTitle}
                                                     list={list}
                                                     isSelected={isSelected}
                                                     setCurrentPage = {setCurrentPage}
                                                     handleClick={handleClick}
                                                     handleIconClick={handleIconClick}
                                                     selectedValues={selectedValues}
                                                     setSelectedValues={setSelectedValues}
                                                     publishATicket={publishATicket}
                                                     setColumnTypes = {setColumnTypes}
                                                     setSortType = {setSortType}
                                                     tablePurpose = {tablePurpose}
                                                   /> 
                                                 :
                                                 (tableTitle === 'pickVenues') 
                                                  ?
                                                 <VenuesTableBody
                                                     tableTitle = {tableTitle}
                                                     list={list}
                                                     isSelected={isSelected}
                                                     setCurrentPage = {setCurrentPage}
                                                     handleClick={handleClick}
                                                     handleIconClick={handleIconClick}
                                                     selectedValues={selectedValues}
                                                     setSelectedValues={setSelectedValues}
                                                     publishATicket={publishATicket}
                                                     setColumnTypes = {setColumnTypes}
                                                     setSortType = {setSortType}
                                                     tablePurpose = {tablePurpose}
                                                     isSportsLeagueTable={isSportsLeagueTable}
                                                   /> 
                                                  :
                                                 (tableTitle === 'manualTicketsError')
                                                 ?
                                                 <AddTicketsManuallyErrorTableBody
                                                    list = {list}
                                                    isSelected = {isSelected}
                                                    setCurrentPage = {setCurrentPage}
                                                    setColumnTypes = {setColumnTypes}
                                                    setSortType = {setSortType}
                                                  /> : 
                                                  (tableTitle === 'superUsersTable') 
                                                  ?
                                                 <SuperUsersTableBody
                                                    list = {list}
                                                    isSelected = {isSelected}
                                                    setCurrentPage= {setCurrentPage}
                                                    handleClose = {handleClose}
                                                    setColumnTypes= {setColumnTypes}
                                                    setSortType = {setSortType}
                                                    refetchSuperUsersData={refetchSuperUsersData}
                                                    setSuperUsersList={setSuperUsersList}
                                                   /> : 
                                                   (tableTitle === 'auditLogitixLogs') ?
                                                   <AuditLogitixLogsTableBody
                                                    list = {list}
                                                    isSelected = {isSelected}
                                                    setCurrentPage= {setCurrentPage}
                                                    setColumnTypes= {setColumnTypes}
                                                    setSortType = {setSortType}
                                                   /> :
                                                  <AffiliatePopupUsersTableBody
                                                    list={list}
                                                    isSelected={isSelected}
                                                    setCurrentPage= {setCurrentPage}
                                                    setColumnTypes={setColumnTypes}
                                                    setSortType = {setSortType}
                                                    affiliateDetailsView = {affiliateDetailsView}
                                                    setAffiliateDetailsView = {setAffiliateDetailsView}
                                                  /> 
                                                  
              )
            }
              
            </Table>
          </TableContainer>
        </div>
      </div>
      {showTable || isSuperUserListTicketsEmpty ? '' : <div className={styles.noDataMessage}>{`No Data Found`}</div>}

      {
        showPaginationFooter
      ? 
      ((tableTitle === 'affiliate' && globalState.profile.userRole === roles.AFFILIATER_ADMIN) || (tableTitle === 'superUsersTable') || (tableTitle === 'auditLogitixLogs')) ? null :
      <div className={styles.pagination}>
        <div className={styles.selectperPage}>
          <div>
            <label className={styles.paginationLabel}>Show</label>
          </div>
          <div>
            <FormControl size="small" variant="outlined" className="row-count">
              <Select
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                IconComponent={KeyboardArrowDown}
                variant="outlined"
                classes={{
                  root: styles.customSelect,
                  select: styles.customSelectOutline,
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={styles.paginationContainer}>
          {paginationBoxCount ?
           <Pagination
           count={paginationBoxCount}
           shape="rounded"
           variant="outlined"
           page={currentPage}
           onChange={handlePageChange}
           classes={{ul: styles.paginationItem, }}
           sx={{
             "& .MuiPaginationItem-root.Mui-selected": {
               color: "white",
               backgroundColor: "#5D75F8",
             },
           }}
         />: ''}
        </div>
      </div>
      : ""
     }
      </>
  );
};

export default AppTable;
